import { addressDataTransformer, addressDataTransformerFashion, importAddressDataTransformerFashion } from './addressDataTransformer';

export const addressArrayTransformer = (data: any) => {
  if (!data || !data.length) {
    return [];
  }
  let transformedArray: any = [];
  data.map((address: any) => {
    const transformedAddress = addressDataTransformer(address);
    if (transformedAddress.isSetDefault) {
      transformedArray.unshift(transformedAddress);
    } else {
      transformedArray.push(transformedAddress);
    }
  });
  return transformedArray;
};

export const addressArrayTransformerFashion = (data: any) => {
  if (!data || !data.length) {
    return [];
  }
  let transformedArray: any = [];
  data.map((address: any) => {
    const transformedAddress = addressDataTransformerFashion(address);
    if (transformedAddress.isSetDefault) {
      transformedArray.unshift(transformedAddress);
    } else {
      transformedArray.push(transformedAddress);
    }
  });
  return transformedArray;
};

export const importAddressArrayTransformerFashion = (data: any) => {
  if (!data || !data.length) {
    return [];
  }
  let transformedArray: any = [];
  data.map((address: any) => {
    const transformedAddress = importAddressDataTransformerFashion(address);
    if (transformedAddress.isSetDefault) {
      transformedArray.unshift(transformedAddress);
    } else {
      transformedArray.push(transformedAddress);
    }
  });
  return transformedArray;
};
